import { render, staticRenderFns } from "./transferIntoAbroad.vue?vue&type=template&id=b1e2af7c&scoped=true&"
import script from "./transferIntoAbroad.vue?vue&type=script&lang=js&"
export * from "./transferIntoAbroad.vue?vue&type=script&lang=js&"
import style0 from "./transferIntoAbroad.vue?vue&type=style&index=0&id=b1e2af7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e2af7c",
  null
  
)

export default component.exports